import React from 'react';

const TestimonialsTab = ({ testimonials, onOpenModal, onDeleteTestimonial, onApproveTestimonial }) => {
    return (
        <div className="admin-tab-content">
            <div className="admin-card">
                <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Client Testimonials &amp; User Reviews ({testimonials.length})</h3>
                    <button className="admin-btn admin-btn-primary" onClick={() => onOpenModal('testimonial')}>
                        <i className="fa fa-plus m-r5" /> Add Testimonial
                    </button>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Client Name</th>
                                    <th>Rating</th>
                                    <th>Status</th>
                                    <th>Testimonial Quote</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {testimonials.map((t) => {
                                    const isApproved = t.isApproved !== false;
                                    return (
                                        <tr key={t.id} style={{ backgroundColor: isApproved ? 'transparent' : 'rgba(254, 243, 199, 0.4)' }}>
                                            <td>
                                                <strong>{t.name}</strong>
                                                {/* {t.isUserSubmitted && (
                                                    <span style={{ display: 'block', fontSize: '11px', color: '#0284c7', fontWeight: '700' }}>
                                                        <i className="fa fa-globe m-r3" /> Web Visitor Review
                                                    </span>
                                                )} */}
                                            </td>
                                            <td><span className="admin-pill bg-gold">★ {t.rating || 5} Stars</span></td>
                                            <td>
                                                {isApproved ? (
                                                    <span className="admin-pill" style={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: '800' }}>
                                                         Approved 
                                                    </span>
                                                ) : (
                                                    <span className="admin-pill" style={{ backgroundColor: '#fef3c7', color: '#92400e', fontWeight: '800' }}>
                                                        ⌛ Pending Approval
                                                    </span>
                                                )}
                                            </td>
                                            <td style={{ maxWidth: '300px' }}>"{t.quote}"</td>
                                            <td>
                                                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                                    {!isApproved && onApproveTestimonial && (
                                                        <button
                                                            className="admin-btn"
                                                            onClick={() => onApproveTestimonial(t.id)}
                                                            style={{
                                                                backgroundColor: '#10b981',
                                                                color: '#ffffff',
                                                                border: 'none',
                                                                padding: '5px 10px',
                                                                fontSize: '12px',
                                                                borderRadius: '6px',
                                                                fontWeight: '700',
                                                                cursor: 'pointer'
                                                            }}
                                                            title="Approve & Publish Live"
                                                        >
                                                            <i className="fa fa-check m-r3" /> Approve
                                                        </button>
                                                    )}
                                                    <button className="admin-btn-icon btn-edit" onClick={() => onOpenModal('testimonial', t)} title="Edit">
                                                        <i className="fa fa-pencil" />
                                                    </button>
                                                    <button className="admin-btn-icon btn-delete" onClick={() => onDeleteTestimonial(t.id)} title="Delete">
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestimonialsTab;
